import { render, staticRenderFns } from "./UcInvoiceGeneratorControls.yaml?vue&type=template&id=08352b4c&component"
import script from "./UcInvoiceGeneratorControls.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceGeneratorControls.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports